module.exports = __webpack_public_path__ + "img/pocket.9cd82fcc.png";